module.exports = "images/slash.beceab51.png";